// ================================
// Carousel JavaScript
// ================================
$(document).ready(function () {

  $(".owl-carousel").owlCarousel();

  $('.testimonial').owlCarousel({
    loop: true,
    responsiveClass: true,
    dots: true,
    margin: 40,
    responsive: {
      0: { items: 2, nav: true, margin: 5 },
      600: { items: 2, nav: false },
      1000: { items: 2, nav: true, loop: false },
      1200: { items: 3, nav: true, loop: false }
    }
  });

  $('.Flip_carousel').owlCarousel({
    loop: true,
    responsiveClass: true,
    dots: false,
    margin: 40,
    autoplay: true,
    autoplayTimeout: 5000,
    merge: true,
    autoplayHoverPause: false,
    nav: false,
    responsive: {
      0: { items: 1, nav: false, margin: 5 },
      600: { items: 1, nav: false },
      1000: { items: 2, nav: true },
      1200: { items: 3, nav: true }
    }
  });

  $('.full_width .owl-carousel').owlCarousel({
    loop: true,
    responsiveClass: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    nav: false,
    responsive: {
      0: { items: 1 },
      1200: { items: 1 }
    }
  });

  $('.owl-carousel').owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    dots: false,
    responsive: {
      0: { items: 2, nav: true },
      600: { items: 3, nav: false },
      1000: { items: 5, nav: true, loop: false }
    }
  });

  // ================================
  // Instagram filtration JavaScript
  // ================================
  $(window).on('load', function () {
    $('.instagram-gallery-medium a').children().filter("video").each(function () {
      $(this).parent().remove();
    });
  });

  // ================================
  // Make all multicard clickable
  // ================================
  jQuery("#Slider-template--14790728974372__49d2f0fd-2527-439a-8660-c7f467250a5c .multicolumn-card, #Slider-template--14790728974372__efaccf41-f248-4d10-bb3b-abe3d9530ea4 .multicolumn-card").click(function () {
    window.location = $(this).find("a").attr("href");
    return false;
  });

  jQuery("#shopify-section-template--14790728974372__multicolumn_XzBjBd .multicolumn-card, #Slider-template--14790728974372__b06b21f4-195b-4f87-80ee-6af7a681673b .multicolumn-card").click(function () {
    window.location = $(this).find("a").attr("href");
    return false;
  });

  jQuery("#shopify-section-template--14790728974372__multicolumn_pnjieh .multicolumn-card").click(function () {
    window.location = $(this).find("a").attr("href");
    return false;
  });


  // ================================
  // Scroll behavior
  // ================================
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 10) {
      $("body").addClass("on-scroll_show");
    } else {
      $("body").removeClass("on-scroll_show");
    }
  });

}); // ✅ END document.ready


// ================================
// LocalStorage Collection Popups
// ================================
if (localStorage.getItem("event_URL") !== "events") {
  if (window.location.href === "https://www.aiwaflowers.ae/collections/events-decoration") {
    setTimeout(function () {
      $('.collection_popup').addClass("show_popup");
    }, 6000);
    $(".close_popup").click(function () {
      $('.collection_popup').removeClass("show_popup");
    });
    localStorage.setItem("event_URL", "events");
  }
}

if (localStorage.getItem("bridal_URL") !== "bridal") {
  if (window.location.href === "https://www.aiwaflowers.ae/collections/bridal-flower-bouquet") {
    setTimeout(function () {
      $('.collection_popup').addClass("show_popup");
    }, 6000);
    $(".close_popup").click(function () {
      $('.collection_popup').removeClass("show_popup");
    });
    localStorage.setItem("bridal_URL", "bridal");
  }
}

// ================================
// Valentine PDP Value Line (SAFE)
// ================================
(function () {

  const IS_AR = (window.Shopify && window.Shopify.locale === 'ar') ||
                document.documentElement.lang === 'ar' ||
                document.documentElement.getAttribute('dir') === 'rtl';

  const mapEn = {
    "Cupid's Kiss": "A timeless Valentine's gift — 35 premium red roses, elegantly wrapped.",
    "Elegant Whispers": "A bold Valentine's statement — 55 red roses with heart details in sleek black wrap.",
    "Forever Yours": "The grandest Valentine's gesture — 201 velvety red roses in a luxurious dome bouquet.",
    "In my Heart": "Romantic elegance for Valentine's — 25–35 red roses with a golden accent in a heart box.",
    "Love Key": "A meaningful Valentine's keepsake — 'A Key To My Heart' vintage token of love.",
    "Love Notes": "Classic Valentine's charm — 25 premium red roses, beautifully wrapped in white.",
    "Love, Wrapped": "A grand Valentine's declaration — 101 radiant red roses in a pure white wrap.",
    "Lux Dream": "Romantic and unforgettable — 101 red roses with ribbons and heart charms.",
    "Stolen Heart": "The ultimate Valentine's gesture — 501 red roses crafted in a heart-shaped design.",
    "Strawberry Kisses": "Sweet Valentine's delight — juicy strawberries in a heart box with satin ribbon.",
    "Sweet Obsession": "A fresh Valentine's twist — premium strawberries arranged in a romantic bouquet.",
    "Trio Red Infinity Roses": "Everlasting Valentine's romance — 3 preserved red roses under a crystal-clear dome.",
    "You & Me": "Passion and sweetness for Valentine's — 25 red roses with a heart box of strawberries.",
    "1001 Reasons to Love": "An unforgettable Valentine's legacy — 1001 premium red roses in a heart bouquet.",
    "Single Red Infinity Rose": "A lasting Valentine's symbol — one preserved red rose under glass that stays beautiful for years."
  };

  const mapAr = {
    "Cupid's Kiss": "هدية عيد حب خالدة — 35 وردة حمراء فاخرة ملفوفة بأناقة.",
    "Elegant Whispers": "إعلان حب جريء — 55 وردة حمراء مع تفاصيل على شكل قلوب بغلاف أسود أنيق.",
    "Forever Yours": "أفخم لفتة لعيد الحب — 201 وردة حمراء مخملية في باقة قبة فاخرة.",
    "In my Heart": "أناقة رومانسية لعيد الحب — 25 إلى 35 وردة حمراء مع لمسة ذهبية في صندوق على شكل قلب.",
    "Love Key": "تذكار ذو معنى لعيد الحب — 'مفتاح إلى قلبي' رمز حب كلاسيكي.",
    "Love Notes": "سحر عيد الحب الكلاسيكي — 25 وردة حمراء فاخرة ملفوفة بأناقة باللون الأبيض.",
    "Love, Wrapped": "إعلان حب كبير — 101 وردة حمراء متألقة في غلاف أبيض ناصع.",
    "Lux Dream": "رومانسي لا يُنسى — 101 وردة حمراء مع شرائط وتفاصيل قلب.",
    "Stolen Heart": "اللفتة المثالية لعيد الحب — 501 وردة حمراء بتصميم على شكل قلب.",
    "Strawberry Kisses": "لذة عيد الحب — فراولة طازجة في صندوق على شكل قلب مع شريط حرير.",
    "Sweet Obsession": "لمسة منعشة لعيد الحب — فراولة فاخرة في باقة رومانسية.",
    "Trio Red Infinity Roses": "رومانسية أبدية — 3 ورود حمراء محفوظة تحت قبة كريستالية.",
    "You & Me": "شغف وحلاوة لعيد الحب — 25 وردة حمراء مع صندوق قلب من الفراولة.",
    "1001 Reasons to Love": "إرث لا يُنسى لعيد الحب — 1001 وردة حمراء فاخرة في باقة قلب.",
    "Single Red Infinity Rose": "رمز حب دائم — وردة حمراء واحدة محفوظة تحت الزجاج تظل جميلة لسنوات."
  };

  const map = IS_AR ? mapAr : mapEn;

  if (!document.querySelector('.product__title h1, h1.product__title, h1')) return;

  function getTitle() {
    const h1 = document.querySelector('.product__title h1') || document.querySelector('h1');
    return h1 ? h1.textContent.trim() : "";
  }

  function getShortDesc() {
    var mapped = map[getTitle()];
    if (mapped) return mapped;
    // Prefer the LOCALE-AWARE product description (translated on /ar) over the meta description,
    // so the short line is Arabic on Arabic pages, English on English.
    var rte = document.querySelector('.product__description');
    if (rte && rte.textContent.trim().length > 15) {
      var t = rte.textContent.trim().replace(/\s+/g, ' ');
      var m = t.match(/^[\s\S]*?[.!؟。](\s|$)/); // first sentence, no lookbehind (older-Safari safe)
      return (m ? m[0].trim() : t).slice(0, 200);
    }
    var md = document.querySelector('meta[name="description"]');
    if (md && md.content && md.content.trim().length > 15) return md.content.trim();
    return '';
  }

  function inject() {
    // 2026-10-23: normally rendered by sections/main-product.liquid already; only the seasonal map overrides it
    const existing = document.getElementById('aiwa-valentine-value-line');
    if (existing) {
      const mapped = map[getTitle()];
      if (mapped && existing.textContent !== mapped) existing.textContent = mapped;
      return;
    }
    const line = getShortDesc();
    if (!line) return;

    const price = document.querySelector('.price') || document.querySelector('[data-price]');
    if (!price) return;

    // 2026-06-12: plain short description after the price (no heart, no box, normal text)
    // 2026-08-06: insert after the reviews trust line (if present) rather than
    // directly after price, so "Rated X by our clients" stays right under price.
    const shortDescAnchor = document.querySelector('.aiwa-trust-line') || price;
    const el = document.createElement('div');
    el.id = 'aiwa-valentine-value-line';
    el.className = 'aiwa-short-desc';
    el.textContent = line;
    shortDescAnchor.insertAdjacentElement('afterend', el);

    if (!document.getElementById('aiwa-short-desc-css')) {
      var s = document.createElement('style'); s.id = 'aiwa-short-desc-css';
      s.textContent = '.aiwa-short-desc{margin:10px 0 4px;font-size:14px;line-height:1.55;color:#555;font-weight:400;letter-spacing:0}[dir="rtl"] .aiwa-short-desc{text-align:right}';
      document.head.appendChild(s);
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', inject)
    : inject();

  document.addEventListener('shopify:section:load', inject);
  document.addEventListener('variant:change', inject);

})();


// ================================
// Free Delivery + Time-based Availability + Trust Lines (FINAL)
// ================================
(function () {

  window.AIWA_DELIVERY_NOTE_VERSION = "v3-2026-03-18";

  const ID = 'aiwa-free-delivery-line';
  const NOTE_ID = 'aiwa-delivery-availability-note';
  const VIDEO_ID = 'aiwa-video-approval-line';
  const FRESH_ID = 'aiwa-fresh-flower-line';

  const PRICE_SELECTORS = [
    '.no-js-hidden[id^="price-template"]',
    '.price.price--large.price--on-sale.price--show-badge',
    '.price.price--large',
    '.price',
    '[data-testid="product-price"]',
    '[data-price]',
    '.product__info-container .price'
  ];

  function findAnchorEl() {
    for (const sel of PRICE_SELECTORS) {
      const el = document.querySelector(sel);
      if (!el) continue;

      if (el.classList && el.classList.contains('price') && el.parentElement) {
        return el.parentElement;
      }
      return el;
    }
    return null;
  }

  const IS_AR_FN = () => (window.Shopify && window.Shopify.locale === 'ar') ||
                         document.documentElement.lang === 'ar' ||
                         document.documentElement.getAttribute('dir') === 'rtl';

  const SAME_DAY_CUTOFF_HOUR = 19; // 7:00 PM Dubai time — last same-day order (matches SAME_DAY_LAST_MIN in aiwa-cart-polish.liquid)
  const COUNTDOWN_ID = 'aiwa-delivery-countdown';

  function getDubaiTime() {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Dubai",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23"
    }).formatToParts(new Date());
    const get = (t) => parts.find(p => p.type === t)?.value;
    return { hh: Number(get("hour")) % 24, mm: Number(get("minute")), ss: Number(get("second")) };
  }

  function getCountdownData() {
    const { hh, mm, ss } = getDubaiTime();
    const nowSec = hh * 3600 + mm * 60 + ss;
    const cutoffSec = SAME_DAY_CUTOFF_HOUR * 3600;
    const beforeOpen = hh < 8;
    const pastCutoff = nowSec >= cutoffSec;

    if (beforeOpen) {
      return { mode: 'before-open' };
    }
    if (pastCutoff) {
      return { mode: 'next-day' };
    }
    const remain = cutoffSec - nowSec;
    const rh = Math.floor(remain / 3600);
    const rm = Math.floor((remain % 3600) / 60);
    const rs = remain % 60;
    return { mode: 'countdown', hours: rh, minutes: rm, seconds: rs };
  }

  // 2026-10-23 redesign ("quiet line"): the note is now a small-caps label and the
  // countdown element always carries the second line (styles at the end of base.css).
  // 2026-10-23: label, timer line and delivery icon share ONE clock reading per tick, so at
  // 7 PM / midnight they can't disagree for a second.
  function getDubaiAvailabilityMessage(data) {
    data = data || getCountdownData();
    if (data.mode === 'next-day') {
      if (IS_AR_FN()) return "التوصيل في اليوم التالي · دبي والشارقة";
      return "Next-Day Delivery · Dubai & Sharjah";
    }
    if (IS_AR_FN()) return "التوصيل في نفس اليوم · دبي والشارقة";
    return "Same-Day Delivery · Dubai & Sharjah";
  }

  // Third icon under the price: Next-Day on 'Next-Day Delivery' products and after the 7 PM cutoff
  function getDeliveryCellLabel(data) {
    const next = window.aiwaNextDayOnly || (data || getCountdownData()).mode === 'next-day';
    if (IS_AR_FN()) return next ? 'توصيل في اليوم التالي<br>دبي' : 'توصيل في نفس اليوم<br>دبي';
    return next ? 'Next-Day Delivery<br>Dubai' : 'Same-Day Delivery<br>Dubai';
  }

  function renderCountdown() {
    const data = getCountdownData();
    const cell = document.querySelector('#aiwa-risk-grid [data-aiwa-delivery-cell]');
    const cellLabel = getDeliveryCellLabel(data);
    if (cell && cell.innerHTML !== cellLabel) cell.innerHTML = cellLabel;

    const el = document.getElementById(COUNTDOWN_ID);
    if (!el) return;
    if (window.aiwaNoSameDayTimer) { el.style.display = 'none'; return; }
    const is_ar = IS_AR_FN();

    // keep the label in step if the mode flips while the page is open (e.g. at 7 PM)
    const labelEl = document.querySelector('#aiwa-delivery-availability-note .aiwa-free-text');
    const label = getDubaiAvailabilityMessage(data);
    if (labelEl && labelEl.textContent !== label) labelEl.textContent = label;

    let line;
    if (data.mode === 'countdown') {
      const pad = (n) => String(n).padStart(2, '0');
      const u = is_ar ? ['س', 'د', 'ث'] : ['h', 'm', 's'];
      const part = (n, unit) => `${pad(n)}<span class="aiwa-countdown-unit">${unit}</span>`;
      const timeStr = `${part(data.hours, u[0])} ${part(data.minutes, u[1])} ${part(data.seconds, u[2])}`;
      line = is_ar
        ? `اطلب خلال <strong class="aiwa-countdown-time">${timeStr}</strong> لتصلك اليوم`
        : `Order within <strong class="aiwa-countdown-time">${timeStr}</strong> to receive it today`;
    } else if (data.mode === 'before-open') {
      line = is_ar ? 'متاح اليوم ابتداءً من 8:00 صباحاً بتوقيت دبي' : 'Available today from 8:00 AM, Dubai time';
    } else {
      line = is_ar ? 'اطلب الآن لتصلك غداً' : 'Order now to receive it tomorrow';
    }
    const html = `<span class="aiwa-countdown-label">${line}</span>`;
    if (el.innerHTML !== html) el.innerHTML = html;
    el.style.display = '';
  }

  // Start countdown ticker (updates every second). Each tick is scheduled just after the next
  // full second — a plain setInterval drifts and now and then jumped two seconds at once.
  let _countdownTimer = null;
  function startCountdownTicker() {
    if (_countdownTimer) return;
    (function tick() {
      renderCountdown();
      _countdownTimer = setTimeout(tick, 1000 - (Date.now() % 1000) + 20);
    })();
  }

function runAll() {
  if (!document.querySelector('.product__title h1, h1.product__title, .product, .product__info-container')) return;

  const anchor = findAnchorEl();
  if (!anchor) return;

  // 2026-08-06: chain the risk-grid/note/countdown/qty-wa-row stack after
  // the reviews trust line (if present), not directly after price — keeps
  // "Rated X by our clients" sitting right under price as designed, instead
  // of getting buried under all this promo content.
  const chainAnchor = document.querySelector('.aiwa-trust-line') || anchor;

  const is_ar = IS_AR_FN();

  const trustStrings = is_ar ? {
    videoMain: 'الموافقة بالفيديو <strong>قبل التوصيل</strong>',
    videoSub: 'شاهدها أولاً لتتأكد أنها مثالية 100%',
    freshMain: '<strong>ضمان نضارة الزهور</strong>',
    freshSub: 'زهور نضرة في كل طلب',
    freeMain: 'توصيل مجاني وسريع في <strong>دبي والشارقة</strong>',
    freeSub: 'استلم زهورك اليوم، بدون أي تأخير'
  } : {
    videoMain: 'Video Approval <strong>Before Delivery</strong>',
    videoSub: "See it first to make sure it's 100% perfect",
    freshMain: '<strong>Fresh Flower Guarantee</strong>',
    freshSub: 'Fresh Flowers Every Time',
    freeMain: 'Free & Fast Delivery in <strong>Dubai & Sharjah</strong>',
    freeSub: 'Get Your Flowers Today, No Delays'
  };

  // === 2026-06-12 — 4 RISK-REVERSAL ICON GRID (horizontal, matches mockup) ===
  const RISK_ID = 'aiwa-risk-grid';
  const riskItems = is_ar ? [
    {ic:'video',  l1:'موافقة بالفيديو',   l2:'قبل التوصيل'},
    {ic:'flower', l1:'ضمان نضارة',        l2:'الزهور'},
    {ic:'truck',  l1:'توصيل في نفس اليوم', l2:'دبي'}
  ] : [
    {ic:'video',  l1:'Video Approval',    l2:'Before Delivery'},
    {ic:'flower', l1:'Fresh Flowers',     l2:'Guaranteed'},
    {ic:'truck',  l1:'Same-Day Delivery', l2:'Dubai'}
  ];
  const RISK_ICONS = {
    video:  'https://www.aiwaflowers.ae/cdn/shop/t/79/assets/aiwa-icon-floral-design.png',
    flower: 'https://www.aiwaflowers.ae/cdn/shop/t/79/assets/aiwa-icon-premium-quality.png',
    truck:  'https://www.aiwaflowers.ae/cdn/shop/t/79/assets/aiwa-icon-signature-service.png'
  };
  let freeLine = document.getElementById(RISK_ID); // keep var name `freeLine` for the downstream note/whatsapp chain
  if (!freeLine) {
    freeLine = document.createElement('div');
    freeLine.id = RISK_ID;
    freeLine.className = 'aiwa-risk-grid';
    freeLine.innerHTML = riskItems.map(function(it){
      if (it.ic === 'truck') return '<div class="aiwa-risk-cell"><span class="aiwa-risk-ic"><img src="'+RISK_ICONS[it.ic]+'" alt="" loading="lazy" width="28" height="28"></span><span class="aiwa-risk-lbl" data-aiwa-delivery-cell>'+getDeliveryCellLabel()+'</span></div>';
      return '<div class="aiwa-risk-cell"><span class="aiwa-risk-ic"><img src="'+RISK_ICONS[it.ic]+'" alt="" loading="lazy" width="28" height="28"></span><span class="aiwa-risk-lbl">'+it.l1+'<br>'+it.l2+'</span></div>';
    }).join('');
  }
  if (chainAnchor.nextElementSibling !== freeLine) {
    chainAnchor.insertAdjacentElement('afterend', freeLine);
  }
  if (!document.getElementById('aiwa-risk-grid-css')) {
    var rgs = document.createElement('style'); rgs.id = 'aiwa-risk-grid-css';
    rgs.textContent = '.aiwa-risk-grid{display:grid !important;grid-template-columns:repeat(3,1fr);gap:6px;margin:16px 0;padding:14px 2px;border-top:1px solid #ece6dc;border-bottom:1px solid #ece6dc}.aiwa-risk-cell{display:flex;flex-direction:column;align-items:center;text-align:center;gap:7px;padding:0 2px}.aiwa-risk-ic{color:#490808;width:24px;height:24px;display:inline-flex;flex-shrink:0}.aiwa-risk-ic img{width:100%;height:100%;object-fit:contain}.aiwa-risk-lbl{font-size:10.5px;line-height:1.3;font-weight:600;color:#3a3a3a;letter-spacing:0}@media(max-width:430px){.aiwa-risk-grid{gap:4px}.aiwa-risk-lbl{font-size:9.5px}.aiwa-risk-ic{width:22px;height:22px}}@media(min-width:750px){.aiwa-risk-lbl{font-size:12px}.aiwa-risk-ic{width:28px;height:28px}}';
    document.head.appendChild(rgs);
  }

  // NOTE (deduped)
  const msg = getDubaiAvailabilityMessage();

  document.querySelectorAll(`#${NOTE_ID}`).forEach((el, i) => {
    if (i > 0) el.remove();
  });

  const duplicateTexts = [
    "Delivery available today in Dubai & Sharjah. For other UAE areas, please confirm availability with our customer service team.",
    "التوصيل متاح اليوم في دبي والشارقة. لمناطق الإمارات الأخرى، يُرجى التأكيد مع فريق خدمة العملاء.",
    "Delivery available today in Dubai & Sharjah.",
    "التوصيل متاح اليوم في دبي والشارقة.",
    "Order now for next-day delivery in Dubai & Sharjah.",
    "اطلب الآن للتوصيل غداً في دبي والشارقة."
  ];
  document.querySelectorAll('.aiwa-delivery-availability-note').forEach((el) => {
    const textEl = el.querySelector('.aiwa-free-text');
    if (
      el.id !== NOTE_ID &&
      textEl &&
      duplicateTexts.includes(textEl.textContent.trim())
    ) {
      el.remove();
    }
  });

  let note = document.getElementById(NOTE_ID);

  if (!note) {
    note = document.createElement('div');
    note.id = NOTE_ID;
    note.className = 'aiwa-delivery-availability-note';
    note.innerHTML = `
      <span class="aiwa-free-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg></span>
      <span class="aiwa-free-text"></span>
    `;
  }

  note.querySelector('.aiwa-free-text').textContent = msg;
  // No same-day promise on Coming Back Soon / Next-Day Delivery products (flag set in snippets/aiwa-cbs-guard.liquid)
  note.style.display = window.aiwaNoSameDayTimer ? 'none' : '';

  if (freeLine.nextElementSibling !== note) {
    freeLine.insertAdjacentElement('afterend', note);
  }

  // COUNTDOWN TIMER (below availability note)
  let countdown = document.getElementById(COUNTDOWN_ID);
  if (!countdown) {
    countdown = document.createElement('div');
    countdown.id = COUNTDOWN_ID;
    countdown.className = 'aiwa-delivery-countdown';
  }
  if (note.nextElementSibling !== countdown) {
    note.insertAdjacentElement('afterend', countdown);
  }
  startCountdownTicker();

  // WHATSAPP ORDER BUTTON (below countdown)
  const WA_ID = 'aiwa-wa-order-btn';
  let waBtn = document.getElementById(WA_ID);
  if (!waBtn) {
    const title = document.querySelector('.product__title h1, h1.product__title, h1');
    const priceEl = document.querySelector('.price-item--sale, .price-item--regular');
    const productTitle = title ? title.textContent.trim() : '';
    const productPrice = priceEl ? priceEl.textContent.trim() : '';
    const productUrl = window.location.href;

    const waMsg = is_ar
      ? encodeURIComponent(`مرحباً، أنا مهتم بـ ${productTitle} (${productPrice}) — ${productUrl}`)
      : encodeURIComponent(`Hi, I'm interested in ${productTitle} (${productPrice}) — ${productUrl}`);

    waBtn = document.createElement('a');
    waBtn.id = WA_ID;
    waBtn.href = `https://wa.me/971525866552?text=${waMsg}`;
    waBtn.target = '_blank';
    waBtn.rel = 'noopener';
    waBtn.className = 'aiwa-wa-order-btn';
    waBtn.innerHTML = is_ar
      ? `<svg width="18" height="18" viewBox="0 0 448 512" fill="#25D366"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>
        <span>اطلب الآن</span>`
      : `<svg width="18" height="18" viewBox="0 0 448 512" fill="#25D366"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>
        <span>Order Now</span>`;
  }
  // 2026-06-12: Quantity + WhatsApp SIDE BY SIDE, placed after the next-day note
  var qtyEl = document.querySelector('.product-form__quantity');
  var qwRow = document.getElementById('aiwa-qty-wa-row');
  if (!qwRow) { qwRow = document.createElement('div'); qwRow.id = 'aiwa-qty-wa-row'; qwRow.className = 'aiwa-qty-wa-row'; }
  if (countdown.nextElementSibling !== qwRow) { countdown.insertAdjacentElement('afterend', qwRow); }
  if (qtyEl && qtyEl.parentElement !== qwRow) { qwRow.appendChild(qtyEl); }
  if (waBtn.parentElement !== qwRow) { qwRow.appendChild(waBtn); }
  if (!document.getElementById('aiwa-qty-wa-css')) {
    var qwcss = document.createElement('style'); qwcss.id = 'aiwa-qty-wa-css';
    qwcss.textContent = '.aiwa-qty-wa-row{display:flex !important;align-items:stretch;gap:12px;margin:14px 0}.aiwa-qty-wa-row>.product-form__quantity{margin:0 !important;flex:none !important;width:calc(50% - 6px) !important;min-width:0 !important;max-width:none !important;box-sizing:border-box !important}.aiwa-qty-wa-row>.product-form__quantity .quantity{width:100% !important;min-width:0 !important;max-width:none !important;box-sizing:border-box !important;background:#fff !important;border-color:rgba(73,8,8,0.25) !important}.aiwa-qty-wa-row .form__label{position:absolute !important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}.aiwa-qty-wa-row>.aiwa-wa-order-btn{flex:none !important;width:calc(50% - 6px) !important;min-width:0 !important;margin:0 !important;box-sizing:border-box !important;display:inline-flex;align-items:center;justify-content:center;white-space:nowrap}@media(max-width:380px){.aiwa-qty-wa-row{gap:8px}.aiwa-qty-wa-row>.product-form__quantity{width:calc(50% - 4px) !important}.aiwa-qty-wa-row>.aiwa-wa-order-btn{width:calc(50% - 4px) !important;padding-left:8px !important;padding-right:8px !important;gap:5px !important}}';
    document.head.appendChild(qwcss);
  }
}

// init
document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', runAll)
  : runAll();

document.addEventListener('shopify:section:load', runAll);
document.addEventListener('variant:change', runAll);

let t = null;
const mo = new MutationObserver(function () {
  if (t) return;
  t = setTimeout(() => { t = null; runAll(); }, 50);
});
mo.observe(document.documentElement, { childList: true, subtree: true });

})();
/* === 2026-06-12 — PDP STICKY ADD-TO-CART BAR (thumbnail+name+price left, button right) === */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  // 2026-10-23: also match Arabic "145.00 درهم" (number first) — the fallback dumped hidden labels incl. "sold out"
  function txtPrice(el){ if(!el) return ''; var m=el.textContent.match(/(?:AED|د\.إ)\s?[\d,.]+|\d[\d,.]*\s?(?:AED|درهم|د\.إ)/i); return m?m[0]:el.textContent.replace(/regular price|sale price|from/ig,'').replace(/\s+/g,' ').trim(); }
  // 2026-07-18 (QA fix): main price re-renders via VariantSelects.renderProductInfo()
  // swapping #price-<section>.innerHTML — no 'variant:change' event is ever dispatched
  // (the listeners below in this file are dead code). Observe that swap directly.
  function watchPrice(bar){
    var priceOut = bar.querySelector('.aiwa-satc__price');
    var container = document.querySelector('[id^="price-"]');
    if (!priceOut || !container) return;
    var sync = function(){ priceOut.textContent = txtPrice(document.querySelector('.price__regular .price-item, .price-item--regular, .price .price-item, .price')); };
    new MutationObserver(sync).observe(container, { childList: true, subtree: true, characterData: true });
  }
  // 2026-07-18 (QA P0 fix): consent banner and sticky ATC bar are both position:fixed
  // at the bottom — raising z-index can't fix an overlap, they must be stacked.
  function watchConsentOffset(bar){
    var consent = document.getElementById('aiwa-consent');
    if (!consent) return;
    var apply = function(){
      var h = consent.hasAttribute('hidden') ? 0 : consent.getBoundingClientRect().height;
      bar.style.setProperty('--aiwa-consent-offset', h + 'px');
    };
    apply();
    if (window.ResizeObserver) new ResizeObserver(apply).observe(consent);
    new MutationObserver(apply).observe(consent, { attributes: true, attributeFilter: ['hidden'] });
  }
  function init(){
    if (document.getElementById('aiwa-sticky-atc')) return;
    var addBtn = document.querySelector('button[name="add"], .product-form__submit');
    var h1 = document.querySelector('h1.product__title, .product__title h1, h1');
    if (!addBtn || !h1) return;
    var priceEl = document.querySelector('.price__regular .price-item, .price-item--regular, .price .price-item, .price');
    var img = document.querySelector('.product__media img, .product-media img, [id*="Slider"] img, .swiper img, .product__column-sticky img, .product img');
    var isAr = document.documentElement.getAttribute('dir') === 'rtl';
    var name = h1.textContent.trim();
    var price = txtPrice(priceEl);
    var imgSrc = img ? (img.currentSrc || img.src) : '';

    var bar = document.createElement('div');
    bar.id = 'aiwa-sticky-atc'; bar.className = 'aiwa-sticky-atc';
    bar.innerHTML =
      '<div class="aiwa-satc__info">' +
        (imgSrc ? '<img class="aiwa-satc__img" src="' + imgSrc + '" alt="" loading="lazy">' : '') +
        '<div class="aiwa-satc__txt"><span class="aiwa-satc__name">' + name + '</span><span class="aiwa-satc__price">' + price + '</span></div>' +
      '</div>' +
      '<button type="button" class="aiwa-satc__btn">' + (isAr ? 'أضف إلى السلة' : 'Add to Cart') + '</button>';
    document.body.appendChild(bar);
    bar.querySelector('.aiwa-satc__btn').addEventListener('click', function () {
      var real = document.querySelector('button[name="add"], .product-form__submit');
      if (real) real.click();
    });
    watchPrice(bar);
    watchConsentOffset(bar);

    // Show IMMEDIATELY, a beat after the product image loads (NOT scroll-gated)
    function reveal(){ bar.classList.add('is-visible'); document.body.classList.add('aiwa-has-sticky-atc'); }
    if (img && !img.complete) { img.addEventListener('load', function(){ setTimeout(reveal, 250); }, { once: true }); setTimeout(reveal, 1200); }
    else { setTimeout(reveal, 450); }
    // Kill the OLD sticky-info-strip / "You're adding" popup from global.js — it re-creates itself,
    // so static CSS isn't enough: remove on sight + MutationObserver to remove every re-injection.
    function killOld(){ var o = document.querySelectorAll('#aiwa-sticky-info-strip, .aiwa-sticky-info-strip'); for (var i=0;i<o.length;i++) o[i].remove(); }
    killOld();
    if (window.MutationObserver) { new MutationObserver(killOld).observe(document.body, { childList: true, subtree: true }); }

    if (!document.getElementById('aiwa-satc-css')) {
      var s = document.createElement('style'); s.id = 'aiwa-satc-css';
      s.textContent = '#aiwa-sticky-info-strip,.aiwa-sticky-info-strip,#ddddEnableSubmitButtonOnReady,.aiwa-sticky-add-to-cart,.sticky-add-to-cart,.product-sticky-atc{display:none !important;visibility:hidden !important;pointer-events:none !important}.aiwa-sticky-atc{position:fixed;left:10px;right:10px;bottom:calc(10px + var(--aiwa-consent-offset,0px));z-index:99990;display:flex;align-items:center;gap:12px;background:#fff;border:1px solid #ece6dc;border-radius:0;box-shadow:0 8px 30px rgba(17,17,17,.16);padding:8px 10px;padding-bottom:calc(8px + env(safe-area-inset-bottom));transform:translateY(160%);opacity:0;transition:transform .28s cubic-bezier(.32,.72,0,1),opacity .28s;pointer-events:none}.aiwa-sticky-atc.is-visible{transform:none;opacity:1;pointer-events:auto}.aiwa-satc__info{display:flex;align-items:center;gap:10px;min-width:0;flex:1 1 auto}.aiwa-satc__img{width:46px;height:46px;border-radius:0;object-fit:cover;flex-shrink:0}.aiwa-satc__txt{display:flex;flex-direction:column;min-width:0}.aiwa-satc__name{font-size:13px;font-weight:600;color:#1a1a1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.aiwa-satc__price{font-size:13px;font-weight:700;color:#490808}.aiwa-satc__btn{flex:0 0 auto;background:#490808;color:#fff;border:0;border-radius:0;padding:13px 22px;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit;letter-spacing:.02em}.aiwa-satc__btn:active{opacity:.9}@media(min-width:750px){.aiwa-sticky-atc{left:0;right:0;bottom:var(--aiwa-consent-offset,0px);width:auto;max-width:none;border-radius:0;border:0;border-top:1px solid #ece6dc;box-shadow:0 -6px 24px rgba(17,17,17,.09);padding:12px max(24px,calc((100vw - 1160px)/2));gap:24px}.aiwa-sticky-atc .aiwa-satc__img{width:54px;height:54px}.aiwa-sticky-atc .aiwa-satc__info{gap:14px}.aiwa-sticky-atc .aiwa-satc__name{font-size:15px}.aiwa-sticky-atc .aiwa-satc__price{font-size:15px}.aiwa-sticky-atc .aiwa-satc__btn{padding:14px 44px;font-size:15px;border-radius:0}}body.aiwa-has-sticky-atc{padding-bottom:calc(78px + env(safe-area-inset-bottom))}@media(min-width:750px){body.aiwa-has-sticky-atc{padding-bottom:82px}}';
      document.head.appendChild(s);
    }
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();

/* === 2026-06-12 — Desktop PDP: shrink oversized gallery + balance/center columns === */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  if (document.getElementById('aiwa-pdp-desktop-css')) return;
  var s = document.createElement('style'); s.id = 'aiwa-pdp-desktop-css';
  s.textContent = '@media(min-width:990px){.product.product--large{gap:56px !important;align-items:flex-start !important;justify-content:center !important}.product--large>.product__media-wrapper{flex:0 0 480px !important;max-width:480px !important;width:480px !important}.product--large>.product__info-wrapper{flex:0 1 560px !important;max-width:560px !important;width:560px !important}.product--large .product__media img,.product--large .product__media-item img{border-radius:0}}';
  (document.head || document.documentElement).appendChild(s);
})();
